import {
    getCard,
    listCards
} from './queries';
import {
    createCard,
    deleteCard,
    updateCard,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    Card,
    CreateCard,
    DeleteCard,
    GetCard,
    ListCards,
    UpdateCard
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();


export const fetchRecords = async (customerId: string, limit?: number, nextToken?: string) => {

    const response = await client.graphql<GraphQLQuery<ListCards>>(
        {
            query: listCards,
            variables: {
                filter: {
                    customerId: customerId
                },
                limit,
                nextToken,
            },
        });

    return response.data?.listCards;
};

export const fetch = async (customerId: string, id: string) => {

    const response = await client.graphql<GraphQLQuery<GetCard>>(
        {
            query: getCard,
            variables: {
                customerId: customerId,
                id: id
            },
        });
    return response.data?.getCard;
};

export const add = async (payload: object) => {

    const response = await client.graphql<GraphQLQuery<CreateCard>>(
        {
            query: createCard,
            variables: {
                input: payload
            },
        });

    return response.data?.createCard;
};

export const update = async (record: Card) => {

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateCard>>(
        {
            query: (updateCard),
            variables: {input: record},
        });
    return response.data?.updateCard;
};

export const deleteRecord = async (customerId: string, id: string) => {

    const response = await client.graphql<GraphQLQuery<DeleteCard>>(
        {
            query: (deleteCard),
            variables: {
                input: {
                    customerId: customerId,
                    id: id
                }
            },

        });
    return response.data?.deleteCard;
};
